import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { localFullDateTime, isoDate } from 'utils/LocalDateTimeHelper';
import { Link } from 'react-router';
import { toSlug } from 'utils'

import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import { loadEntries } from '../reducers/myStableEntries';

import MyStableUnauthenticatedUser from '../components/MyStableUnauthenticatedUser';

require('./MyStableNextEntries.scss');

@standardAsyncConnect([
  userServiceLayoutConnect({
    then: ({getState, dispatch}) => dispatch(loadEntries(getState().common.userService.subscriptions)),
    state: state => ({auth: state.common.auth, myStableEntries: state.horseRacing.myStableEntries})
  })
])
@catchLifeCycleErrors
export default class MyStableNextEntries extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    myStableEntries: PropTypes.object
  }

  render() {
    if (!this.props.isLoggedIn()) {
      return <MyStableUnauthenticatedUser/>
    }
    const { props: { myStableEntries: { entries } } } = this;
    return (
      <section className="nextEntries">
        <MetaDataWrapper title="Next Entries"/>
        <h3 className="section-title my-stable-subtitle">Next Entries</h3>
        <MyStableEntriesTable label='Horses' entries={entries.horse || []} extractor={horseMatch}/>
        <MyStableEntriesTable label='Jockeys' entries={entries.jockey || []} extractor={jockeyMatch}/>
        <MyStableEntriesTable label='Trainers' entries={entries.trainer || []} extractor={trainerMatch}/>
      </section>
    );
  }
}

function genericMatch(race) {
  const matchingRide = race.rides[0];
  return [['Horse', matchingRide.horse.name || 'Not Specified'],
          ['Jockey', matchingRide.jockey.name || 'Not Specified'],
          ['Trainer', matchingRide.trainer.name || 'Not Specified']]
}

function extractAtIndex(parts, mainIndex) {
  return {
    mainName: parts.splice(mainIndex, 1)[0][1],
    parts
  };
}

function horseMatch(race) {
  return extractAtIndex(genericMatch(race), 0);
}
function jockeyMatch(race) {
  return extractAtIndex(genericMatch(race), 1);
}
function trainerMatch(race) {
  return extractAtIndex(genericMatch(race), 2);
}

function MyStableEntriesTable({label, entries, extractor}) {
  return (
    <section className="my-stable-entries">
      <div className="my-stable-section-header">
        <span className="my-stable-section-header-key" id={label+"-section"}>{label}</span>
        <span className="my-stable-section-header-remove"></span>
      </div>
      <div className="">
        {
          entries.length > 0 ?
            <table className="my-stable-table">
              <tbody>
                { entries.map(({race, matched}) =>
                    <tr className="my-stable-entries-row" key={`${matched}-${race.race_summary.race_summary_reference.id}-${race.rides[0].horse.name}`}>
                      <td>
                        <Link to={`/racing/racecards/${isoDate(race.race_summary.date)}/${toSlug(race.race_summary.course_name)}/racecard/${race.race_summary.race_summary_reference.id}/${toSlug(race.race_summary.name)}`}>
                          <MyStableEntryMatchRow {...extractor(race)} />
                          <p className="my-stable-entries-what-when">
                            {!!race.race_summary.date && !!race.race_summary.time && localFullDateTime(`${race.race_summary.date}T${race.race_summary.time}Z`)}
                            {!!race.race_summary.name && ' - '+race.race_summary.name}
                          </p>
                          <p className="my-stable-entries-where">
                            {!!race.race_summary.course_name && 'Course: '+race.race_summary.course_name+' '}
                            {!!race.race_summary.distance && 'Distance: '+race.race_summary.distance.replace(/0m |0f |0y/ig , '')+' '}
                            {!!race.race_summary.race_class && 'Class: '+race.race_summary.race_class}
                          </p>
                        </Link>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          :
            <div className="my-stable-entries-none">No entries for your selections</div>
        }
      </div>
    </section>
  )
}

MyStableEntriesTable.propTypes = {
  label: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(PropTypes.shape({
    matched: PropTypes.number.isRequired,
    race: PropTypes.shape({
      race_summary: PropTypes.shape({
        race_summary_reference: PropTypes.shape({
          id: PropTypes.number
        })
      })
    })
  })),
  extractor: PropTypes.func.isRequired
}

function MyStableEntryMatchRow(props) {
  return (
    <p className="my-stable-entries-who">
      <span className="my-stable-entries-horse">{props.mainName}</span>
      { ' - ' }
      {props.parts.map(part => part.join(': ')).join(', ')}
    </p>
  )
}

MyStableEntryMatchRow.propTypes = {
  mainName: PropTypes.string.isRequired,
  parts: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStableNextEntries.js